import InventoryContainer from './inventory-container'

export default InventoryContainer
